import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsSkipBack2: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16m3.5-12l-5 2.857V4.5h-2v7h2V9.143l5 2.857z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsSkipBack2
